import React from 'react';
import { motion } from 'framer-motion';
import { CHECKOUT_URL, PRICE } from '../data/content';
import { trackPixelEvent } from './MetaPixel';
export function ClosingBlock() {
  return <section id="cierre" className="w-full scroll-mt-16 bg-plum px-5 py-14 sm:py-20" data-id="element-22" data-mp="2aph1a4g4hb95">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-23" data-mp="2arjyb8fp04nd">
        <span className="mb-5 inline-block rounded-full border border-gold/50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-gold" data-id="element-24" data-mp="1ryzl0zch884o">
          Aura Viva 2026
        </span>

        <h2 className="font-serif-display text-2xl font-bold leading-tight text-cream sm:text-4xl" data-id="element-25" data-mp="1i0s76pdhi66w">
          Tu próximo paso puede empezar hoy.
        </h2>

        <p className="mt-4 text-sm leading-relaxed text-cream/80 sm:text-base" data-id="element-26" data-mp="1d2qow6nvuawh">
          Dejá de guardar recursos sin saber por dónde comenzar. Aura Viva 2026 reúne prácticas
          visuales y herramientas de autocuidado para que encuentres una propuesta clara para tu
          momento.
        </p>

        <span className="mt-8 font-serif-display text-[52px] font-bold leading-none text-gold sm:text-6xl" data-id="element-27" data-mp="3dt5lpzt5afi8">
          {PRICE}
        </span>
        <p className="mt-3 text-sm font-medium text-cream/85" data-id="element-28" data-mp="ae0751okz5a6">
          Pago único · Sin suscripción · Acceso de por vida
        </p>

        <motion.a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout')} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-7 flex min-h-[58px] w-full max-w-md items-center justify-center rounded-[10px] bg-aura px-4 py-4 text-center text-[13px] font-extrabold tracking-tight text-white shadow-lg shadow-plum/40 ring-1 ring-gold/40 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-lg sm:tracking-normal" data-id="element-29" data-mp="fcbdh2fo2xnn">
          SÍ, QUIERO ACCEDER A AURA VIVA 2026
        </motion.a>
        <p className="mt-3 text-xs text-cream/75" data-id="element-30" data-mp="mw3yjun8coia">
          🇦🇷 Disponible actualmente en Argentina · Garantía de 7 días
        </p>
      </motion.div>
    </section>;
}